export default __webpack_public_path__ + "static/media/healthCare.2d0cba27.png";